import { render, staticRenderFns } from "./b-ticket-wallet-buttons.vue?vue&type=template&id=44ad671e&scoped=true"
import script from "./b-ticket-wallet-buttons.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-ticket-wallet-buttons.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./b-ticket-wallet-buttons.vue?vue&type=style&index=0&id=44ad671e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ad671e",
  null
  
)

export default component.exports